import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/usecase01.png'
import _imports_1 from '@/assets/img/usecase02.png'
import _imports_2 from '@/assets/img/usecase03.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-4dd1e5ef")

_pushScopeId("data-v-4dd1e5ef")
const _hoisted_1 = { class: "usecase" }
const _hoisted_2 = { class: "contents-usecase" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", { class: "txt title-usecase" }, "onlyliveの使い方", -1)
const _hoisted_4 = { class: "contents-use-case-group-sm" }
const _hoisted_5 = { class: "flow-box" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "step-img-request",
  src: _imports_0
}, null, -1)
const _hoisted_7 = { class: "flow-box" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  class: "step-img",
  src: _imports_1
}, null, -1)
const _hoisted_9 = { class: "flow-box" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", {
  class: "step-img",
  src: _imports_2
}, null, -1)
const _hoisted_11 = { class: "contents-use-case-group-md" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "use-case-images" }, [
  /*#__PURE__*/_createVNode("div", { class: "use-case-image-box" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "step-img-request",
      src: _imports_0
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "use-case-image-box" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "step-img",
      src: _imports_1
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "use-case-image-box" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "step-img",
      src: _imports_2
    })
  ])
], -1)
const _hoisted_13 = { class: "use-case-items" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_UsecaseItem = _resolveComponent("UsecaseItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_UsecaseItem, {
            headline: "STEP1",
            body: "通話を予約\n（先着順）",
            text: "通話予約できる人から通話したい人を選び、予約をしましょう。通話予約にはアプリ内で購入できるコインが必要なので、事前に購入しておくとスムーズです。"
          })
        ]),
        _createVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_UsecaseItem, {
            headline: "STEP2",
            body: "着信に応答して\n1体1の会話を楽しむ",
            text: "通話予約後はタレントが電話をかけてくれるので見逃しません。二人きりの会話を楽しみましょう。",
            subText: "※通話されるお客様のカメラは起動せず、タレントの映像のみが配信されます。※通話の様子は音声なしの状態で第三者からも閲覧可能です。"
          })
        ]),
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_UsecaseItem, {
            headline: "STEP3",
            body: "世界に1枚だけの\n写真をリクエスト",
            text: "通話中に、忘れずに写真のリクエストをしましょう。"
          })
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_UsecaseItem, {
            headline: "STEP1",
            body: "通話を予約\n（先着順）",
            text: "通話予約できる人から通話したい人を選び、予約をしましょう。通話予約にはアプリ内で購入できるコインが必要なので、事前に購入しておくとスムーズです。"
          }),
          _createVNode(_component_UsecaseItem, {
            headline: "STEP2",
            body: "着信に応答して\n1体1の会話を楽しむ",
            text: "通話予約後はタレントが電話をかけてくれるので見逃しません。二人きりの会話を楽しみましょう。",
            subText: "※通話されるお客様のカメラは起動せず、タレントの映像のみが配信されます。※通話の様子は音声なしの状態で第三者からも閲覧可能です。"
          }),
          _createVNode(_component_UsecaseItem, {
            headline: "STEP3",
            body: "世界に1枚だけの\n写真をリクエスト",
            text: "通話中に、忘れずに写真のリクエストをしましょう。"
          })
        ])
      ])
    ])
  ]))
})